import {
    RESET_TF_OPTS,
    SET_SRC_SEC_CODE,
    SET_SRC_SEC_TYPE,
    SET_SRC_SUBJECT,
    SET_TGT_SEC_CODE,
    SET_TGT_SEC_TYPE,
    SET_TGT_SUBJECT
} from '../actionTypes'

const initialState = {
    srcSubject: {},
    srcSecCode: '',
    srcSecType: '16901',
    tgtSubject: {},
    tgtSecCode: '',
    tgtSecType: '16901',
}

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_SRC_SUBJECT:
            state.srcSubject = action.payload || {}
            return state

        case SET_SRC_SEC_CODE:
            state.srcSecCode = action.payload || ''
            return state

        case SET_SRC_SEC_TYPE:
            let srcSecType = ''
            if (action.payload === null) {
                srcSecType = '16901'
            } else {
                if (state.srcSecType === '16901') srcSecType = '16902';
                else srcSecType = '16901'
            }
            state.srcSecType = srcSecType
            console.log("transferEnroll: type", action.type)
            console.log("transferEnroll: payload", action.payload)
            console.log("transferEnroll: state", state.srcSecType)
            return state

        case SET_TGT_SUBJECT:
            state.tgtSubject = action.payload || {}
            return state

        case SET_TGT_SEC_CODE:
            state.tgtSecCode = action.payload || ''
            return state

        case SET_TGT_SEC_TYPE:
            let tgtSecType = ''
            if (action.payload === null) {
                tgtSecType = '16901'
            } else {
                if (state.tgtSecType === '16901') tgtSecType = '16902';
                else tgtSecType = '16901'
            }
            state.tgtSecType = tgtSecType
            return state

        case RESET_TF_OPTS:
            let stateTmp = {
                srcSubject: {},
                srcSecCode: '',
                srcSecType: '16901',
                tgtSubject: {},
                tgtSecCode: '',
                tgtSecType: '16901',
            }
            return {...stateTmp}

        default:
            return state
    }
}
